// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__231l_","name":"styles_name__1u7LK","phone":"styles_phone__3vKHu"};